import { useMount, useUnmount } from 'react-use'
import PropTypes from 'prop-types'

const OnMount = ({ onMount, onUnmount }) => {
    useMount(() => onMount && onMount())
    useUnmount(() => onUnmount && onUnmount())
    return null
}

OnMount.propTypes = {
    onMount: PropTypes.func,
    onUnmount: PropTypes.func,
}

export default OnMount
